import { makeStyles } from '@material-ui/core';

export const useStyles = makeStyles(({ spacing, breakpoints, palette }) => ({
  container: {
    marginTop: spacing(6.25),
    marginBottom: spacing(6.25),
    [breakpoints.up('lg')]: {
      marginTop: spacing(2),
      marginBottom: spacing(8),
    },
  },
  rootText: {
    margin: spacing(3, 15.75, 0, 15.75),
    fontSize: spacing(3),
    fontWeight: spacing(100),
    fontFamily: 'Open Sans',
    textAlign: 'center',
    [breakpoints.down('sm')]: {
      fontSize: spacing(3),
      margin: spacing(2),
    },
  },
  rootTextSub: {
    margin: spacing(3, 15.75, 3, 15.75),
    fontSize: spacing(3.375),
    fontWeight: spacing(100),
    fontFamily: 'Open Sans',
    textAlign: 'center',
    [breakpoints.down('sm')]: {
      fontSize: spacing(3),
      margin: spacing(2),
    },
    [breakpoints.only('lg')]: {
      margin: spacing(1, 15.75, 1, 15.75),
    },
  },
  rootTextSubHeader: {
    fontSize: spacing(2),
    fontWeight: spacing(70),
    fontFamily: 'Open Sans',
    textAlign: 'center',
    [breakpoints.down('sm')]: {
      fontSize: spacing(1.5),
    },
  },
  subHeader: {
    margin: spacing(2, 0),
    fontSize: spacing(2.5),
    fontWeight: spacing(50),
    fontFamily: 'Open Sans',
    textAlign: 'center',
    [breakpoints.down('sm')]: {
      fontSize: spacing(1.5),
      margin: spacing(1),
    },
  },
  image: { width: '200px', height: '200px', display: 'flex', justifyContent: 'center', alignItems: 'center' },
  confirmButton: {
    marginTop: spacing(1),
    backgroundColor: palette.green.dark,
    color: palette.white.main,
    width: spacing(15),
    margin: spacing(2),
    letterSpacing: '0px',
    textTransform: 'unset',
    '&:hover': {
      backgroundColor: palette.green.dark,
    },
  },
  percentage: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'baseline',
    height: '27px',
    fontWeight: 'bold',
    fontSize: spacing(2.25),
  },
  circularProgressContainer: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    // height: '-webkit-fill-available',
    fontWeight: 'bold',
    padding: spacing(3, 0, 3, 0),
    [breakpoints.only('lg')]: {
      padding: spacing(2, 0, 0, 0),
    },
  },
  socialIconContainer: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'end',
    marginTop: '8px',
    // [breakpoints.down('xs')]: {
    //   // minWidth: '320px',

    // },
    flexDirection: 'column',

    '@media (max-width:375px)': {
      flexDirection: 'column',
    },
  },
  socialIconSubContainer: {
    display: 'flex',
    justifyContent: 'center',
    gap: '0.2rem',
    [breakpoints.down('xs')]: {
      display: 'flex',
      justifyContent: 'space-evenly',
      alignItems: 'center',
    },
  },
  socialMediaIconButton: {
    [breakpoints.down('sm')]: {
      padding: '2px',
      marginTop: '8px',
      width: '39.74px',
      height: '46.3px',
    },
  },
  heroText: {
    fontSize: spacing(2),
    fontWeight: 'bolder',
    fontFamily: 'Open Sans',
    textAlign: 'center',
    [breakpoints.down('sm')]: {
      fontSize: spacing(2),
    },
  },
  onBoardContainer: {
    display: 'flex',
    justifyContent: 'center',
    width: '100%',
    marginTop: '1rem',
  },

  onBoard: {
    display: 'flex',
    justifyContent: 'center',
    marginTop: '2rem',
    width: '100%',
    maxWidth: '800px',
    height: '400px',
    gap: '2rem',
    border: '2px solid black',
    boxSizing: 'border-box',

    [breakpoints.down('sm')]: {
      flexDirection: 'column',
      alignItems: 'center',
      gap: '1rem',
    },
  },
  // mainContainer: {
  //   width: '100%',
  //   maxWidth: '1200px',
  //   margin: '0 auto',
  //   padding: '0 1rem',
  // },
  progressCard: {
    width: '700px',
    backgroundColor: 'white',
    padding: '2rem',
    textAlign: 'center',

    [breakpoints.down('sm')]: {
      width: '100%',
      padding: '1rem',
    },
  },

  onBoardSocialContainer: {
    display: 'flex',
    justifyContent: 'space-evenly',
    alignItems: 'center',
    marginRight: '21rem',
    // gap: '5rem',
    marginTop: '0.5rem',
    [breakpoints.down('sm')]: {
      flexDirection: 'column',
      marginRight: 0,
      gap: '1.5rem',
    },
  },

  onBoardSocialThump: {
    display: 'flex',
    alignItems: 'center',
    gap: '1rem',

    [breakpoints.down('sm')]: {
      flexDirection: 'row',
    },
  },

  onBoardSocial: {
    display: 'flex',
    alignItems: 'center',
    gap: '0.5rem',

    [breakpoints.down('sm')]: {
      flexDirection: 'row',
      gap: '0',
    },
  },

  onBoardCopyContainer: {
    display: 'flex',
    alignItems: 'flex-end',
    justifyContent: 'flex-start',
    backgroundColor: 'white',
    borderRadius: '8px',
    marginLeft: '2rem',

    [breakpoints.down('sm')]: {
      display: 'none',
      // flexDirection: 'column',
      // marginLeft: 0,
      // marginTop: '1rem',
    },
  },

  onBoardCopyContainerMobile: {
    display: 'none',

    [breakpoints.down('sm')]: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      marginTop: '2.2rem',
      // backgroundColor: 'white',
      // borderRadius: '8px',
      // marginLeft: '2rem',
    },
  },

  onBoardCopyCard: {
    display: 'flex',
    alignItems: 'flex-start',
    justifyContent: 'flex-start',
    flexDirection: 'column',
    [breakpoints.down('sm')]: {
      display: 'flex',
      alignItems: 'flex-start',
      justifyContent: 'flex-start',
      marginBottom: '1.5rem',
      // backgroundColor: 'white',
      // borderRadius: '8px',
      // marginLeft: '2rem',
    },
  },
  progressCard1: {
    // width: '700px',
    backgroundColor: 'white',
    // padding: '2rem',
    textAlign: 'center',

    [breakpoints.down('sm')]: {
      width: '100%',
      padding: '1rem',
    },
  },

  rootTextSub1: {
    margin: spacing(3, 15.75, 3, 15.75),
    fontSize: spacing(2),
    fontWeight: spacing(100),
    fontFamily: 'Open Sans',
    textAlign: 'center',
    [breakpoints.down('sm')]: {
      fontSize: spacing(3),
      margin: spacing(2),
    },
    [breakpoints.only('lg')]: {
      margin: spacing(1, 15.75, 1, 15.75),
    },
  },
  rootTextSubHeader1: {
    fontSize: spacing(1.3),
    fontWeight: spacing(70),
    fontFamily: 'Open Sans',
    textAlign: 'center',
    [breakpoints.down('sm')]: {
      fontSize: spacing(1.5),
    },
  },
  subHeader1: {
    margin: spacing(2, 0),
    fontSize: spacing(1.5),
    fontWeight: spacing(50),
    fontFamily: 'Open Sans',
    textAlign: 'center',
    [breakpoints.down('sm')]: {
      fontSize: spacing(1.5),
      margin: spacing(1),
    },
  },
  circularProgressContainer1: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    // height: '-webkit-fill-available',
    fontWeight: 'bold',
    marginTop: '-1rem',
    padding: spacing(3, 0, 3, 0),
    [breakpoints.only('lg')]: {
      padding: spacing(2, 0, 0, 0),
    },
  },
  snackBar: {
    '& .MuiSnackbarContent-root': {
      backgroundColor: palette.green.light,
    },
  },
  linkedinContent: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    gap: '0.5rem',
    // marginBottom: '1rem'
  },

  linkedinIcon: {
    display: 'flex',
    alignItems: 'start',
    justifyContent: 'start',
    backgroundColor: 'white',
    borderRadius: '4px',
  },

  linkedinText: {
    fontSize: spacing(2.4),
    fontWeight: spacing(100),
    fontFamily: 'Open Sans',
    textAlign: 'center',
    color: '#0e76a8',
    marginBottom: '-0.2rem',
    [breakpoints.down('sm')]: {
      fontSize: spacing(3),
      margin: spacing(2),
    },
  },
  linkedInsubHeader: {
    margin: spacing(1, 0),
    fontSize: spacing(2),
    fontWeight: spacing(50),
    fontFamily: 'Open Sans',
    textAlign: 'center',
    [breakpoints.down('sm')]: {
      fontSize: spacing(1.5),
      margin: spacing(1),
    },
  },
}));
